import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarOrganizadorConfiguracion } from '../../../../actions/configuracion';

const EliminarOrganizador = ({ organizador, reestablecerOrganizador }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar organizador */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarOrganizadorConfiguracion(organizador?.id));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerOrganizador(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(organizador){
            setEliminarModal(true);
        }
    }, [organizador]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar organizador</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar a <b>{organizador?.nombre}{organizador?.ubicaciones > 0 ? ' con ' + organizador?.ubicaciones + (organizador?.ubicaciones == 1 ? ' ubicación asignada' : ' ubicaciones asignadas') : ''}</b>?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarOrganizador;